module.exports = __webpack_public_path__ + "static/media/iDAI-logo.754cd95e.png";